
import React from "react";

const AppContext = React.createContext(null);

export function useAppContext() {
    return React.useContext(AppContext);
}


export function AppContextProvider({ children }) {

    const [values, setValues] = React.useState(null);

    return (
        <AppContext.Provider value={{ values, setValues }}>
            {children}
        </AppContext.Provider >
    )
}